<template>
  <v-row justify="center">
<!--    <v-list-item-->

<!--        color="primary"-->
<!--        dark-->
<!--        @click="dialog=true"-->
<!--    >-->

<!--      <v-list-item-content>-->
<!--        <v-list-item-title class="comment">Register Applicant</v-list-item-title>-->
<!--      </v-list-item-content>-->
<!--    </v-list-item>-->


    <v-dialog
        v-model="dialog"
        width="480"
    >
      <v-card>
        <Loader :loading="loading" :message="message"/>
        <v-toolbar class="box"  @click.stop="dialog = false">
          <v-icon>mdi-close</v-icon>
          <v-toolbar-title>Close</v-toolbar-title>
        </v-toolbar>
        <div class="comment-content">
          <v-card-title class="comment-heading">Kindly Confirm <br/>Payment </v-card-title>
          <div class="row">
            <v-col>
              <label class="payment-label">Payment Mode</label>
              <p class="payment-details">Bank Transfer</p>

            </v-col>
          </div>

          <div class="row">
            <v-col>
              <label class="payment-label"> Proof of Payment</label>
              <p class="payment-details">Screenshot-2020...App.jpg <span class="error--text ml-7">View</span></p>

            </v-col>
          </div>

          <div class="row">
            <v-col>
              <label class="payment-label">Transaction Date</label>
              <p class="payment-details">September 1st, 2020</p>

            </v-col>
          </div>

          <div class="row">
            <v-col>
              <label class="payment-label">Amount</label>
              <p class="payment-details">N2,000,000</p>

            </v-col>
            <v-col>
              <label class="payment-label">Phone number</label>
              <p class="payment-details">0802 123 4567</p>

            </v-col>
          </div>
          <div class="row">
            <v-col>

              <v-card-actions>
                <v-btn
                    color="red"
                    outlined
                    x-large
                    @click="dialog = false"
                    width="100px"
                >
                  Decline
                </v-btn>
              </v-card-actions>
            </v-col>
            <v-col>

              <v-card-actions>
                <v-btn
                    color="red"
                    class="text--white"
                    depressed
                    x-large
                    @click="dialog = false"
                    width="100px"
                >
                  Accept
                </v-btn>
              </v-card-actions>
            </v-col>
          </div>

        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Loader from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/Loader";
export default {
name: "ConfirmPaymentModal",
  components:{
  Loader
  },
  data(){
    return{
      dialog: false,
      message:"Loading",
      loading:false,


    }
  },
  mounted() {
  this.dialog=true;
  },
  methods:{
  }
}
</script>

<style scoped>
.comment-heading{
  font-weight: 500!important;
  font-size: 32px !important;
  line-height: 33px!important;
  letter-spacing: -0.02em;
  color: #2B1C1C !important;
  margin-left:-17px;
}

.box{
  box-shadow: none!important;
  cursor: pointer;
}
.comment-content{
  margin-left: 52px;
  margin-right: 52px;
  font-family: IBM Plex Sans !important;
  font-style: normal!important;
  font-weight: normal;

}
.payment-label{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;

  color: #2B1C1C;

}
.payment-details{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;

  color: #2B1C1C;


}


</style>